/* Vanilla copy of src/js/script.header.src.js */
// Globals for charts
var _charts = typeof _charts !== 'undefined' ? _charts : {};
var chartTheme = typeof chartTheme !== 'undefined' ? chartTheme : {};
var chartConfig = typeof chartConfig !== 'undefined' ? chartConfig : {};
// Keep global flag
var fixSideBar = typeof fixSideBar !== 'undefined' ? fixSideBar : false;
